import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { useCrmEnrichmentContext } from "../../../contexts/CrmEnrichmentContext";
import CrmEnrichmentJobFiltersContainer, {
    type CrmEnrichmentJobFiltersProps,
} from "../../filters/CrmEnrichmentJobFilters";
import CrmEnrichmentJobWizardHeader from "../CrmEnrichmentJobWizardHeader";

const CrmEnrichmentJobFiltersWizardStep = ({
    onApplyFiltersChange,
    isApplyFiltersSelected,
    filters,
    onAddFilter,
    onDeleteFilter,
    onFilterChange,
    onCrmFieldFilterChange,
    crmFieldOptions,
    selectedJobObject,
}: Omit<CrmEnrichmentJobFiltersProps, "translationKeys">) => {
    const translate = useTranslation();

    const { i18nKeys } = useCrmEnrichmentContext();

    return (
        <>
            <CrmEnrichmentJobWizardHeader
                titleKey="si.crm-enrichment.job-wizard.filters.title"
                descriptionKey="si.crm-enrichment.job-wizard.filters.description"
            />

            <Text
                as="div"
                fontVariant="h6"
                color={colorsPalettes.carbon[400]}
                marginY="24px 0"
            >
                {translate("si.crm-enrichment.job-wizard.filters.subtitle")}
            </Text>

            <CrmEnrichmentJobFiltersContainer
                translationKeys={i18nKeys}
                isApplyFiltersSelected={isApplyFiltersSelected}
                filters={filters}
                crmFieldOptions={crmFieldOptions}
                selectedJobObject={selectedJobObject}
                onApplyFiltersChange={onApplyFiltersChange}
                onAddFilter={onAddFilter}
                onDeleteFilter={onDeleteFilter}
                onFilterChange={onFilterChange}
                onCrmFieldFilterChange={onCrmFieldFilterChange}
            />
        </>
    );
};

export default CrmEnrichmentJobFiltersWizardStep;
